<template>
    <div>
        <v-container fluid>
            <v-row class="p-3">
                <v-col
                        v-for="(image,index) in img"
                        :key="image.id"
                        cols="12"
                        class="mx-auto my-2 card boxStyle"
                        md="2"
                        :data-img="image.id"
                >
                    <v-radio-group class="p-0 m-0" v-model="selectedImage">
                        <v-radio
                                color="indigo"
                                :value="image.value"
                        ></v-radio>
                    </v-radio-group>
                    <img :src="image.full_path"  class="img-fluid"
                         :key="image.id">
                    <p class="text-center my-0 pt-2">{{image.name}}</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "tieBro",
    data() {
        return {
            selectedImage: [],
            img: [
                {id:'1',name:'آکاردئونی',value:'accordion',full_path:require('../../../../../../public/media/site/bro/ta/آکاردئونی.png')},
                {id:'2',name:'معمولی',value:'normal',full_path:require('../../../../../../public/media/site/bro/ta/معمولی.png')},
                {id:'3',name:'دروازه ایی',value:'gate',full_path:require('../../../../../../public/media/site/bro/ta/دروازه-ایی(2).png')},
            ],
            count: 1,
        }
    },
    watch:{
        selectedImage() {
            this.$emit('persianName',this.img.find((x)=>x.value === this.selectedImage).name,"tieBro")
            this.$emit('input', this.selectedImage)
        }
    }
}
</script>

<style scoped>

</style>